import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { checkTokenUnsubscription } from "../../services/Mail_service";

type ResponseCheck = {
  errorStatus?: number | null;
  errorMessage?: string | null;
  success?: string | null;
};

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Extract email from query parameters
  let count: number = 0;
  const [response, setResponse] = useState<ResponseCheck | undefined>();

  useEffect(() => {
    if (token && count < 1) {
      count++;
      checkTokenUnsubscription({ token })
        .then((response) => {
          setResponse((prev?: ResponseCheck) =>
            prev
              ? { ...prev, success: response.message }
              : {
                  success: response.message,
                }
          );
        })
        .catch((error: any) => {
          if (error.response) {
            setResponse((prev?: ResponseCheck) =>
              prev
                ? {
                    ...prev,
                    errorStatus: error.response.status,
                    errorMessage: error.response.message,
                  }
                : {
                    errorStatus: error.response.status,
                    errorMessage: error.response.message,
                  }
            );
          } else {
            setResponse((prev?: ResponseCheck) =>
              prev
                ? {
                    ...prev,
                    errorStatus: error.status,
                    errorMessage: error.message
                  }
                : { 
                  errorStatus: error.status,
                  errorMessage: error.message
                }
            );
          }
        });
    }
    return () => setResponse(undefined);
  }, [token]);

  if (response?.errorStatus) {
    return <>{response?.errorMessage}</>;
  }

  if (response?.success) {
    return <>{response?.success}</>;
  }

  return <>chargement...</>;
};

export default UnsubscribePage;
